(function() {
  function initTableGrid(root) {
    const sections = root.querySelectorAll ? root.querySelectorAll('[data-table-grid]') : [];

    sections.forEach(function(section) {
      const body = section.querySelector('[data-table-grid-body]');
      const items = Array.from(body?.querySelectorAll('.table-g__item') || []);
      const toggle = section.querySelector('[data-table-grid-toggle]');
      const visibleCount = 4;

      if (!body || !toggle || items.length <= visibleCount) {
        if (toggle) toggle.remove();
        return;
      }

      if (section.dataset.tableGridInitialized === 'true') {
        return;
      }
      section.dataset.tableGridInitialized = 'true';

      const hiddenItems = items.slice(visibleCount);

      hiddenItems.forEach(function(item) {
        const fullHeight = item.scrollHeight;
        item.dataset.fullHeight = fullHeight;
        item.classList.add('table-g__item--collapsed');
        item.style.maxHeight = '0px';
      });

      toggle.hidden = false;

      const moreLabel = toggle.dataset.moreLabel || 'View More';
      const lessLabel = toggle.dataset.lessLabel || 'View Less';

      toggle.addEventListener('click', function() {
        const expanded = section.classList.toggle('table-g--expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded ? lessLabel : moreLabel;

        hiddenItems.forEach(function(item) {
          if (expanded) {
            item.classList.remove('table-g__item--collapsed');
            item.style.maxHeight = item.dataset.fullHeight + 'px';
          } else {
            item.style.maxHeight = item.dataset.fullHeight + 'px';
            requestAnimationFrame(function() {
              item.classList.add('table-g__item--collapsed');
              item.style.maxHeight = '0px';
            });
          }
        });

        if (!expanded) {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initTableGrid(document); });
  } else {
    initTableGrid(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target) {
      initTableGrid(event.target);
    }
  });
})();
